import React from "react";

export default function WhyDoCompaniesNeed({ titleColClass, descriptionColClass, heading, whyNeedServices }) {

    return (
        <React.Fragment>
            <section className="p-0 page-title-center-alignment">
                <div className="container">
                    <div className="row align-items-center justify-content-center extra-very-small-screen">
                        <div
                            className="col-xl-8 col-lg-10 text-center position-relative page-title-extra-large"
                            data-anime='{ "el": "childs", "translateY": [-15, 0], "opacity": [0,1], "duration": 300, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'
                        >
                            <h3 className="fw-700 text-dark-gray mb-20px ls-minus-2px">{heading}</h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-0">
                <div className="container">
                    <div className="row mb-7">
                        <div
                            className="col-lg-10 offset-lg-1"
                            data-anime='{ "el": "childs", "translateY": [15, 0], "opacity": [0,1], "duration": 300, "delay": 0, "staggervalue": 100, "easing": "easeOutQuad" }'
                        >
                            {whyNeedServices && whyNeedServices.map((service, index) => {
                                return (
                                    <React.Fragment>
                                        <div className="row">
                                            <div className={titleColClass ?? "col-md-3"}>
                                                <div className="fs-19 fw-600 text-dark-gray">{service.title}</div>
                                            </div>
                                            <div className={(descriptionColClass ?? "col-md-9") + " last-paragraph-no-margin"}>
                                                <p>
                                                    {service.description}
                                                </p>
                                            </div>
                                        </div>
                                        {(whyNeedServices.length > index + 1) && (
                                            <div className="separator-line-1px bg-dark-gray mt-35px mb-35px" />
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    )
}